import * as React from "react";
import { render } from "react-dom";
import "common/sentry";

import Main from "./main.jsx";
import type { Product, ProductDetails } from "types";

declare var product: Product;
declare var product_details: ProductDetails;

// Load the size and addon selectors.
function init() {
  const mountPoint = document.getElementById("mount_point");
  if (mountPoint) {
    render(
      React.createElement(Main, {
        product: product,
        details: product_details
      }),
      mountPoint
    );
  }
}

init();
